"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    PENDING: 'pending',
    ACTIVE: 'active',
    DECLINED: 'declined',
    DELETED: 'deleted',
    RETRACTED: 'retracted',
    ARCHIVED: 'archived',
    ACCEPTED: 'accepted',
    AUTO_DECLINED: 'auto_declined',
};
//# sourceMappingURL=contractStatus.js.map